export default __webpack_public_path__ + "static/media/bg-marketing-digital.48622c13.webp";